import { GET_QUERY_OBJECT_RESULT, GET_QUERY_LIST_RESULT, GET_QUERY_INITIALIZE, GET_QUERY_ERROR, ADD_OBJECT_ATTEMPT, ADD_OBJECT_TWO_STEP_ATTEMPT, ADD_FILE_ATTEMPT, GET_BY_POST_OBJECT_ATTEMPT, GET_QUERY_DATA_ATTEMPT, GET_MULTIPLE_QUERY_DATA_ATTEMPT } from "../Actions/LogisticActions"


const InitialState = {
    AddedSuccessfuly: false,
    GeneralError:'',
    MyCourses:[]
}

export default function QueryReducer(state = InitialState, action){
    switch(action.type){

        case GET_MULTIPLE_QUERY_DATA_ATTEMPT:{
            return {
                ...state,
                ...action.Containers.reduce((r,c) => r = ({...r, ...c}), ({}) )
            }
        }

        case GET_QUERY_INITIALIZE:{
            return {
                ...state,
                ...action.Container
            }
        }

        case GET_QUERY_DATA_ATTEMPT:{
            return {
                ...state,
                ...action.Container
            }
        }
        
        case GET_QUERY_OBJECT_RESULT:{
            return {
                ...state,
                ...action.Container
            }
        }

        case GET_QUERY_LIST_RESULT:{
            return {
                ...state,
                ...action.Container
            }
        }

        case GET_QUERY_ERROR:{
            return {
                ...state,
                ...action.Container
            }
        }
        
        case ADD_OBJECT_ATTEMPT:{
            return {
                ...state,
                ...action.Container
            }
        }

        case ADD_OBJECT_TWO_STEP_ATTEMPT:{
            return {
                ...state,
                ...action.Container
            }
        }

        case ADD_FILE_ATTEMPT:{
            return {
                ...state,
                ...action.Container
            }
        }

        case GET_BY_POST_OBJECT_ATTEMPT:{
            return {
                ...state,
                ...action.Container
            }
        }

        default:
            {
                return {
                    ...state
                }
            }
        
    }


}